import axios from "axios";

const UPDATE_DEALER = "UPDATE_DEALER";

const UPDATE_DEALER_WITH_DEFAULT_STARTED = "UPDATE_DEALER_WITH_DEFAULT_STARTED";
const UPDATE_DEALER_WITH_DEFAULT_FAILURE = "UPDATE_DEALER_WITH_DEFAULT_FAILURE";
const UPDATE_DEALER_WITH_DEFAULT_SUCCESS = "UPDATE_DEALER_WITH_DEFAULT_SUCCESS";

const SAVE_DEALER_SUCCESS = "SAVE_DEALER_SUCCESS";
const SAVE_DEALER_FAILURE = "SAVE_DEALER_FAILURE";
const SAVE_DEALER_STARTED = "SAVE_DEALER_STARTED";

const REPLACE_DEALER_SUCCESS = "REPLACE_DEALER_SUCCESS";
const REPLACE_DEALER_FAILURE = "REPLACE_DEALER_FAILURE";
const REPLACE_DEALER_STARTED = "REPLACE_DEALER_STARTED";

const ADD_DEALER_FAILURE = "ADD_DEALER_FAILURE";
const ADD_DEALER_STARTED = "ADD_DEALER_STARTED";
const ADD_DEALER_SUCCESS = "ADD_DEALER_SUCCESS";

const CLEAR_SYSTEMS_FAILURE = "CLEAR_SYSTEMS_FAILURE";
const CLEAR_TERM_FAILURE = "CLEAR_TERM_FAILURE";

const CREATE_DEALER_CONTRACT_STARTED = "CREATE_DEALER_CONTRACT_STARTED";
const CREATE_DEALER_CONTRACT_FAILURE = "CREATE_DEALER_CONTRACT_FAILURE";
const CREATE_DEALER_CONTRACT_SUCCESS = "CREATE_DEALER_CONTRACT_SUCCESS";

const CHANGE_PRICEBOOK_STARTED = "CHANGE_PRICEBOOK_STARTED";
const CHANGE_PRICEBOOK_FAILURE = "CHANGE_PRICEBOOK_FAILURE";
const CHANGE_PRICEBOOK_SUCCESS = "CHANGE_PRICEBOOK_SUCCESS";

export const addDealerToContract = (dealer, contractId) => {
  return (dispatch) => {
    dispatch(addDealerToContractStarted());

    axios
      .put(`/contracts/${contractId}/add-dealer/`, { dealer_id: dealer.id })
      .then(() => dispatch(addDealerToContractSuccess(dealer)))
      .catch((err) =>
        dispatch(addDealerToContractFailure(err.response.data.ui_message))
      );
  };
};
const addDealerToContractStarted = (err) => ({ type: ADD_DEALER_STARTED });
const addDealerToContractFailure = (error) => ({
  type: ADD_DEALER_FAILURE,
  payload: error,
});
const addDealerToContractSuccess = (dealer) => ({
  type: ADD_DEALER_SUCCESS,
  payload: dealer,
});

export const replaceDealer = (dealer, contractId) => {
  return (dispatch) => {
    dispatch(replaceDealerStarted());

    axios
      .put(`/contracts/${contractId}/add-dealer/`, { dealer_id: dealer.id })
      .then(() => dispatch(removeSalesperson(contractId)))
      .then(() => dispatch(deleteSystems(contractId)))
      .then(() => dispatch(deleteTerm(contractId)))
      .then(() => dispatch(replaceDealerSuccess(dealer)))
      .catch((err) =>
        dispatch(replaceDealerFailure(err.response.data.ui_message))
      );
  };
};

const replaceDealerFailure = (err) => ({ type: REPLACE_DEALER_FAILURE });
const replaceDealerStarted = (err) => ({ type: REPLACE_DEALER_STARTED });
const replaceDealerSuccess = (dealer) => ({
  type: REPLACE_DEALER_SUCCESS,
  payload: dealer,
});

export const updateDealerWithDefault = (dealer, contractId) => {
  return (dispatch) => {
    dispatch(updateDealerWithDefaultStarted());

    axios
      .put(`/contracts/${contractId}/add-dealer/`, { dealer_id: dealer.id })
      .then(() => dispatch(removeSalesperson(contractId)))
      .then(() => dispatch(updateDealerWithDefaultSuccess(dealer)))
      .catch((err) =>
        dispatch(updateDealerWithDefaultFailure(err.response.data.ui_message))
      );
  };
};

const updateDealerWithDefaultStarted = () => ({
  type: UPDATE_DEALER_WITH_DEFAULT_STARTED,
});
const updateDealerWithDefaultFailure = (payload) => ({
  type: UPDATE_DEALER_WITH_DEFAULT_FAILURE,
  payload,
});

const updateDealerWithDefaultSuccess = (dealer) => ({
  type: UPDATE_DEALER_WITH_DEFAULT_SUCCESS,
  payload: dealer,
});

const removeSalesperson = (contractId) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/remove-salesperson/`)
      .then(() => {
        return;
      })
      .catch((err) =>
        dispatch(updateDealerWithDefaultFailure(err.response.data.ui_message))
      );
  };
};

// resets term
// resets systems
export const changePricebook = (bool, contractId) => {
  const postUrl = !bool
    ? "/not-default-pricebook/"
    : `/contracts/${contractId}/reset-systems/`;

  return (dispatch) => {
    dispatch(changePricebookStarted());

    axios
      .put(postUrl, { contract_id: contractId })
      .then(() => dispatch(deleteSystems(contractId)))
      .then(() => dispatch(deleteTerm(contractId)))
      .then(() => dispatch(changePricebookSuccess(bool)))
      .catch((err) =>
        dispatch(changePricebookFailure(err.response.data.ui_message))
      );
  };
};

const changePricebookStarted = () => ({ type: CHANGE_PRICEBOOK_STARTED });
const changePricebookSuccess = (bool) => ({
  type: CHANGE_PRICEBOOK_SUCCESS,
  payload: bool,
});
const changePricebookFailure = (err) => ({
  type: CHANGE_PRICEBOOK_FAILURE,
  payload: err,
});

const deleteSystems = (contractId) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/reset-systems/`)
      .then(() => {
        return;
      })
      .catch((err) =>
        dispatch(changePricebookFailure(err.response.data.ui_message))
      );
  };
};

export const deleteTerm = (contractId) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/reset-term/`)
      .then(() => {
        return;
      })
      .catch((err) =>
        dispatch(changePricebookFailure(err.response.data.ui_message))
      );
  };
};

const createDealerContract = (dealer) => {
  // creates a contract with a dealer
  return (dispatch) => {
    dispatch(createDealerContractStarted());

    axios
      .post("/add-contract/", { dealer_id: dealer.id })
      .then(({ data }) =>
        dispatch(createDealerContractSuccess(data.id, dealer))
      )
      .catch((err) =>
        dispatch(createDealerContractFailure(err.response.data.ui_message))
      );
  };
};

function createDealerContractSuccess(id, dealer) {
  return {
    type: CREATE_DEALER_CONTRACT_SUCCESS,
    payload: {
      id,
      dealer,
    },
  };
}

const createDealerContractStarted = () => ({
  type: CREATE_DEALER_CONTRACT_STARTED,
});
const createDealerContractFailure = (error) => ({
  type: CREATE_DEALER_CONTRACT_FAILURE,
  payload: error,
});

const saveDealerStarted = () => ({
  type: SAVE_DEALER_STARTED,
});

const saveDealer = (dealer, contractId) => {
  // CLEARS TERM, SYSTEMS, SALESPERSON
  // ADDS A DEALER
  return (dispatch) => {
    dispatch(saveDealerStarted());

    axios
      .put(`/contracts/${contractId}/reset-term/`)
      .then(() => dispatch(clearSalesperson(contractId, dealer)))
      .catch((err) =>
        dispatch(saveDealerFailure(err.response.data.ui_message))
      );
  };
};

const saveDealerSuccess = (dealer) => ({
  type: UPDATE_DEALER,
  payload: dealer,
});

const saveDealerFailure = (error) => ({
  type: SAVE_DEALER_FAILURE,
  payload: error,
});

const clearSystems = (contractId, dealer) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/reset-systems/`)
      .then(() => dispatch(clearSalesperson(contractId, dealer)))
      .catch((err) =>
        dispatch(clearSystemsFailure(err.response.data.ui_message))
      );
  };
};

const clearSystemsFailure = (error) => ({
  type: CLEAR_SYSTEMS_FAILURE,
  payload: error,
});

const clearSalesperson = (contractId, dealer) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/remove-salesperson/`)
      .then(() => dispatch(addDealer(contractId, dealer)))
      .catch((err) => dispatch(addDealerFailure(err.response.data.ui_message)));
  };
};

const addDealer = (contractId, dealer) => {
  return (dispatch) => {
    axios
      .put(`/contracts/${contractId}/add-dealer/`, { dealer_id: dealer.id })
      .then(() => dispatch(saveDealerSuccess(dealer)))
      .catch((err) => dispatch(addDealerFailure(err.response.data.ui_message)));
  };
};

const clearTermFailure = (error) => ({
  type: CLEAR_TERM_FAILURE,
  payload: error,
});

export function updateDealer(dealer, contractId = null) {
  if (contractId) {
    return saveDealer(dealer, contractId);
  }

  return createDealerContract(dealer);
}

function dealerReducer(state, action) {
  switch (action.type) {
    case REPLACE_DEALER_STARTED:
      return {
        ...state,
        loading: true,
      };
    case REPLACE_DEALER_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case REPLACE_DEALER_SUCCESS:
      return {
        ...state,
        loading: false,
        dealer: action.payload,
        defaultPricebook: action.payload.default_pricebook,
        salesperson: null,
        systems: [],
        term: {
          ...state.term,
          selected: null,
        },
      };
    case ADD_DEALER_STARTED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_DEALER_SUCCESS:
      return {
        ...state,
        loading: false,
        dealer: action.payload,
        defaultPricebook: action.payload.default_pricebook,
      };
    case ADD_DEALER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CHANGE_PRICEBOOK_STARTED:
      return {
        ...state,
        loading: true,
      };
    case CHANGE_PRICEBOOK_SUCCESS:
      return {
        ...state,
        defaultPricebook: action.payload,
        loading: false,
        systems: [],
        term: {
          ...state.term,
          // additionalCost: '',
          // additionalCostNote: '',
          // downPayment: '',
          selected: null,
        },
      };
    case CHANGE_PRICEBOOK_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CREATE_DEALER_CONTRACT_SUCCESS:
      return {
        ...state,
        dealer: action.payload.dealer,
        id: action.payload.id,
        loading: false,
      };
    case CREATE_DEALER_CONTRACT_STARTED:
      return {
        ...state,
        loading: true,
      };
    case CREATE_DEALER_CONTRACT_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SAVE_DEALER_STARTED:
      return {
        ...state,
        loading: true,
      };
    case SAVE_DEALER_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CLEAR_SYSTEMS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CLEAR_TERM_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case UPDATE_DEALER:
      return {
        ...state,
        dealer: action.payload,
        defaultPricebook: action.payload.default_pricebook,
        loading: false,
        salesperson: null,
        // showPricebookSelect: action.payload.deafult_pricebook,
        // systems: [],
        // term: {
        // ...state.term,
        // additionalCost: '',
        // additionalCostNote: '',
        // downPayment: '',
        // selected: null,
        // }
      };
    case UPDATE_DEALER_WITH_DEFAULT_STARTED:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_DEALER_WITH_DEFAULT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_DEALER_WITH_DEFAULT_SUCCESS:
      return {
        ...state,
        dealer: action.payload,
        loading: false,
        salesperson: null,
        showPricebookSelect: !action.payload.default_pricebook,
        // systems: [],
        // term: {
        // ...state.term,
        // additionalCost: '',
        // additionalCostNote: '',
        // downPayment: '',
        // selected: null,
        // }
      };
    default:
      return state;
  }

  return state;
}

export default dealerReducer;
